import fonts from '@helpers/fonts';
import { Device, from, until } from '@helpers/media';
import styled from 'styled-components';
const Container = styled.div `
  position:relative;
  &[data-layout='horizontal'] {
    @media ${until(Device.DesktopSmall)} {
      display: grid;
      align-items: center;
      grid-template-columns: 1fr 1fr;
      column-gap: 24px;
      row-gap: 18px;
    }

    @media ${from(Device.DesktopSmall)} {
      display: flex;
      align-items: center;
      column-gap: 32px;
    }
  }

  &[data-layout='vertical'] {
    display: flex;
    flex-direction: column;
    row-gap: 12px;
    max-width: 213px;
  }
`;
const Logo = styled.img `
  @media ${until(Device.TabletLarge)} {
    grid-column: 1;
  }

  [data-layout='vertical'] & {
    max-height: 40px;
    object-fit: contain;
    object-position: left;

    @media ${until(Device.TabletLarge)} {
      max-height: 30px;
    }
  }
`;
const RatingImage = styled.img `
  max-height: 40px;
  object-fit: contain;

  @media ${until(Device.TabletLarge)} {
    grid-column: 2;

    [data-layout='vertical'] & {
      max-height: 30px;
      object-fit: contain;
      object-position: left;
    }
  }
`;
const RatingLabel = styled.span `
  flex: 0 1 auto;
  ${fonts.montserrat.regular};
  font-size: 16px;
  line-height: 1em;

  span {
    padding-right: 0.5ch;

    [data-layout='vertical'] & {
      margin-bottom: 0.5ch;
    }
  }

  strong {
    ${fonts.montserrat.bold}
  }

  @media ${until(Device.TabletLarge)} {
    grid-column: 1 / span 2;
  }
`;
const Link = styled.a `
    position:absolute;
    top:0;
    left:0;
    width:100%;
    height:100%;
`;
const TrustpilotBlockStyles = {
    Container,
    Logo,
    RatingImage,
    RatingLabel,
    Link
};
export default TrustpilotBlockStyles;
